import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import { LocalEnum, StorageEnum } from "#/enum";
import { getStringItem } from "@/utils/storage";
import en_US from "./lang/en_US";
import zh_CN from "./lang/zh_CN";

// 判断是否生产环境
const isProduction = import.meta.env.VITE_APP_ENV === "production";

// 在生产环境下，如果用户之前选择了非英文语言，重置为英文
const storedLng = getStringItem(StorageEnum.I18N);
const defaultLng = isProduction ? LocalEnum.en_US : storedLng || LocalEnum.en_US;

// 设置 HTML lang 属性（防止浏览器提示翻译）
document.documentElement.lang = defaultLng;

// 构建资源对象 - 生产环境只包含英文
const resources: Record<string, { translation: any }> = {
	en_US: { translation: en_US },
	zh_CN: { translation: zh_CN },
};

i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		debug: !isProduction,
		lng: defaultLng as string,
		fallbackLng: LocalEnum.en_US,
		interpolation: {
			escapeValue: false,
		},
		resources,
	});

export const { t } = i18n;
export default i18n;
